import apiClient from './api';
import { API_ENDPOINTS } from '@/config/api.config';
import {
  WorkflowListParams,
  WorkflowListResponse,
  WorkflowCreateRequest,
  WorkflowCreateResponse,
  WorkflowStatusResponse,
  WorkflowDetailsResponse,
  WorkflowMetricsResponse,
  WorkflowMetricsParams,
} from '@/types/learning-path-workflow.types';

class LearningPathWorkflowService {
  /**
   * List all workflows with pagination and filtering
   */
  async listWorkflows(params?: WorkflowListParams): Promise<WorkflowListResponse> {
    const response = await apiClient.get<WorkflowListResponse>(
      API_ENDPOINTS.LEARNING_PATH_WORKFLOWS.LIST,
      { params }
    );
    return response.data;
  }

  /**
   * Create a new workflow
   */
  async createWorkflow(data: WorkflowCreateRequest): Promise<WorkflowCreateResponse> {
    const response = await apiClient.post<WorkflowCreateResponse>(
      API_ENDPOINTS.LEARNING_PATH_WORKFLOWS.CREATE,
      data
    );
    return response.data;
  }

  /**
   * Get workflow status by ID
   */
  async getWorkflowStatus(id: string): Promise<WorkflowStatusResponse> {
    const response = await apiClient.get<WorkflowStatusResponse>(
      API_ENDPOINTS.LEARNING_PATH_WORKFLOWS.GET_STATUS(id)
    );
    return response.data;
  }

  /**
   * Get workflow details by ID
   */
  async getWorkflowById(id: string): Promise<WorkflowDetailsResponse> {
    const response = await apiClient.get<WorkflowDetailsResponse>(
      API_ENDPOINTS.LEARNING_PATH_WORKFLOWS.GET_BY_ID(id)
    );
    return response.data;
  }

  /**
   * Activate workflow - auto-assigns learning path to group/role
   */
  async activateWorkflow(id: string): Promise<any> {
    const response = await apiClient.post(
      API_ENDPOINTS.LEARNING_PATH_WORKFLOWS.ACTIVATE(id)
    );
    return response.data;
  }

  /**
   * Deactivate workflow - sets assignment to inactive
   */
  async deactivateWorkflow(id: string): Promise<any> {
    const response = await apiClient.post(
      API_ENDPOINTS.LEARNING_PATH_WORKFLOWS.DEACTIVATE(id)
    );
    return response.data;
  }

  /**
   * Update workflow - updates workflow metadata and notification settings
   */
  async updateWorkflow(id: string, data: any): Promise<any> {
    const response = await apiClient.put(
      API_ENDPOINTS.LEARNING_PATH_WORKFLOWS.UPDATE(id),
      data
    );
    return response.data;
  }

  /**
   * Get workflow metrics dashboard
   */
  async getMetrics(params?: WorkflowMetricsParams): Promise<WorkflowMetricsResponse> {
    const response = await apiClient.get<WorkflowMetricsResponse>(
      API_ENDPOINTS.LEARNING_PATH_WORKFLOWS.METRICS,
      { params }
    );
    return response.data;
  }
}

export default new LearningPathWorkflowService();
